import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { AttendanceAdjustResponse, AttendanceLogResponse, AttendanceResponse, EmployeeAttendanceResponse, EmployeeDataModel, EmployeeDataModelResponse, EmployeeShiftAttendanceResponse, EmployeeShiftCountResponse, MonthAttendanceResponse } from "@gtpl/shared-models/hrms";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Get, Param, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { WhatsappNotifyService } from "./attendance-whatsapp.service";
import { AttendanceService } from "./attendance.service";
import { AttendanceAdjustRequest } from "./dto/attendance-adjustment.request";
import { AttendanceLogRequest } from "./dto/attendance-log.request";
import { AttnAdjustLogReq } from "./dto/attn-adjust-log.request";
import { AttendanceUpdateRequest } from "./dto/attn-update.request";
import { DateReq } from "./dto/date.request";
import { EmpCodeShiftRequest } from "./dto/emp-code-shift.request";
import { EmployeeCodesRequest } from "./dto/emp-codes.request";
import { EmployeeAttDateRequest } from "./dto/empstartdateenddate.request";
import { EmployeeAttendanceRequest } from "./dto/get-emp-attendance.request";
import { LeaveUpdateRequest } from "./dto/leave-update.request";
import { AttendanceMonthRequest } from "./dto/month.request";
import { ShiftAttendanceRequest } from "./dto/shift-emp-count.request";

@Controller('attendance')
@ApiTags('attendance')
export class AttendanceController {
    constructor(
        private attendanceService: AttendanceService,
        private wtsapNotificationService: WhatsappNotifyService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) {

    }

    @Post('/createAttendanceLogs')
    async createAttendanceLogs(@Body() attnLogReq: AttendanceLogRequest): Promise<AttendanceLogResponse> {
        try {
            return await this.attendanceService.createAttendanceLogs(attnLogReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceLogResponse, err);
        }
    }


    @Get('attendanceLog/:logDate/:employeeCode/:downloadDate/:verifyMode/:deviceCode/:direction/:employeeName')
    async attendanceLog(@Param() params: { logDate: string, employeeCode: string, downloadDate: string, verifyMode: string, deviceCode: string, direction: string, employeeName: string }): Promise<GlobalResponseObject> {
        try {
            const req = new AttendanceLogRequest(params.logDate, params.employeeCode, params.downloadDate, params.verifyMode, params.deviceCode, params.direction, params.employeeName);
            return await this.attendanceService.createAttendanceLogs(req);
        } catch (error) {
            return await this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
        }
    }

    @Post('/createAttendance')
    async createAttendance(): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.createAttendance();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/updateEmpLogsByShift')
    async updateEmpLogsByShift(@Body() req: EmpCodeShiftRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.updateEmpLogsByShift(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/updateLeave')
    async updateLeave(@Body() req: LeaveUpdateRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.updateLeave(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/createEmpAttendanceLogs')
    async createEmpAttendanceLogs(@Body() req?: EmployeeCodesRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.createEmpAttendanceLogs(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/createEmpAttnLogForToday')
    async createEmpAttnLogForToday(@Body() req?: EmployeeCodesRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.createEmpAttnLogForToday(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/attendanceAdjustment')
    async attendanceAdjustment(@Body() req: AttnAdjustLogReq): Promise<any> {
        try {
            return await this.attendanceService.attendanceAdjustment(req);
        } catch (err) {
            console.log(err)
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/getAttnAdjustTableData')
    async getAttnAdjustTableData(): Promise<CommonResponse> {
        try {
            return await this.attendanceService.getAttnAdjustTableData();
        } catch (err) {
            console.log(err)
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/updateAttendance')
    async updateAttendance(@Body() req: AttendanceUpdateRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.updateAttendance(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/getAllNonProcessedAttendanceLogs')
    async getAllNonProcessedAttendanceLogs(): Promise<AttendanceLogResponse> {
        try {
            return await this.attendanceService.getAllNonProcessedAttendanceLogs();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceLogResponse, err);
        }
    }

    @Post('/getDataForEmpShiftMapping')
    async getDataForEmpShiftMapping(): Promise<EmployeeDataModelResponse> {
        try {
            return await this.attendanceService.getDataForEmpShiftMapping();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(EmployeeDataModelResponse, err);
        }
    }

    @Post('/getAttendanceData')
    async getAttendanceData(@Body() empAttnReq: EmployeeAttendanceRequest): Promise<EmployeeAttendanceResponse> {
        try {
            return await this.attendanceService.getAttendanceData(empAttnReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(EmployeeAttendanceResponse, err);
        }
    }

    @Post('/getAttendanceDataShiftWise')
    async getAttendanceDataShiftWise(@Body() empAttnReq: EmployeeAttendanceRequest): Promise<EmployeeShiftAttendanceResponse> {
        try {
            return await this.attendanceService.getAttendanceDataShiftWise(empAttnReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(EmployeeShiftAttendanceResponse, err);
        }
    }

    @Post('/getAttendanceCountShiftWise')
    async getAttendanceCountShiftWise(@Body() shiftAttnReq: ShiftAttendanceRequest): Promise<EmployeeShiftCountResponse> {
        try {
            return await this.attendanceService.getAttendanceCountShiftWise(shiftAttnReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(EmployeeShiftCountResponse, err);
        }
    }

    @Post('/getMonthWiseAttendanceReport')
    async getMonthWiseAttendanceReport(@Body() empAttnReq: AttendanceMonthRequest): Promise<MonthAttendanceResponse> {
        try {
            return await this.attendanceService.getMonthWiseAttendanceReport(empAttnReq);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(MonthAttendanceResponse, err);
        }
    }

    @Post('/sendAttendanceStatus')
    async sendAttendanceStatus(): Promise<GlobalResponseObject> {
        try {
            return await this.wtsapNotificationService.sendAttendanceStatus();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, err);
        }
    }

    @Post('/sendworkingAttendanceStatus')
    async sendworkingAttendanceStatus(): Promise<GlobalResponseObject> {
        try {
            return await this.wtsapNotificationService.sendworkingAttendanceStatus();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, err);
        }
    }

    @Post('/sendworkingDailyAttendanceStatus')
    async sendworkingDailyAttendanceStatus(): Promise<GlobalResponseObject> {
        try {
            return await this.wtsapNotificationService.sendworkingDailyAttendanceStatus();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, err);
        }
    }

    @Post('/sendUnitWiseDailyAttendanceStatus')
    async sendUnitWiseDailyAttendanceStatus(): Promise<GlobalResponseObject> {
        try {
            return await this.wtsapNotificationService.sendUnitWiseDailyAttendanceStatus();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(GlobalResponseObject, err);
        }
    }

    // @Post('/createAttendanceLog')
    // async createAttendanceLog(@Body() attnLogReq: AttendanceLogRequest): Promise<AttendanceResponse> {
    //     try {
    //         return await this.attendanceService.createAttendanceLog(attnLogReq);
    //     } catch (err) {
    //         return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
    //     }
    // }

    @Post('/getAllEmpDateAtten')
    async getAllEmpDateAtten(@Body() Req: EmployeeAttDateRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.getAllEmpDateAtten(Req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err);
        }
    }

    @Post('/getAdjustmentData')
    async getAdjustmentData(@Body() Req: AttendanceAdjustRequest): Promise<AttendanceAdjustResponse> {
        try {
            return await this.attendanceService.getAdjustmentData(Req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceAdjustResponse, err)
        }
    }

    @Post('/getPresentEmployeesData')
    async getPresentEmployeesData(@Body() Req: DateReq): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.getPresentEmployeesData(Req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err)
        }
    }

    @Post('/getPresentEmployeeDataByEmpCode')
    async getPresentEmployeeDataByEmpCode(@Body() req: AttendanceAdjustRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.getPresentEmployeeDataByEmpCode(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err)
        }
    }

    @Post('/getUnitDropForAttReport')
    async getUnitDropForAttReport(): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.getUnitDropForAttReport();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err)
        }
    }

    @Post('/updateAttendanceByHR')
    async updateAttendanceByHR(@Body() req: AttendanceUpdateRequest): Promise<AttendanceResponse> {
        try {
            return await this.attendanceService.updateAttendanceByHR(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(AttendanceResponse, err)
        }
    }

    @Post('/getShiftDropForAttReport')
    async getShiftDropForAttReport(): Promise<CommonResponse> {
        try {
            return await this.attendanceService.getShiftDropForAttReport();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err)
        }
    }

    @Post('/getLessWorkingEmployees')
    async getLessWorkingEmployees(): Promise<CommonResponse> {
        try {
            return await this.attendanceService.getLessWorkingEmployees();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err)
        }
    }

    @Post('/getCriteriaNotMatchingReport')
    async getCriteriaNotMatchingReport(): Promise<CommonResponse> {
        try {
            return await this.attendanceService.getCriteriaNotMatchingReport();
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err)
        }
    }
}